import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewBanco = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'banco',
        name: 'Banco',
        component: ViewBanco,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
